const userApps = {
  userApps: 'Программы администратора',
  showing: 'показывается',
  userAppsOf: 'программы из',
  noUserAppsFound: 'Программы пользователя не найдены',
};
export default userApps;
